import React from "react";
import { Helmet } from "react-helmet";

function GarantiaTarimas(){
    return(
        <>
            <Helmet>
                <title>Garantía de productos - Box tarimas | Kamas</title>
            </Helmet>

            <main>
                <div className='block-container'>
                    <section className='block-content d-flex-center-center'>
                        <img src="/assets/imagenes/paginas/servicio-al-cliente/garantia-de-productos/box-tarimas-2.png" alt=""/>
                    </section>
                </div>
            </main>
        </>
    )
}

export default GarantiaTarimas;
